module.exports = __webpack_public_path__ + "img/musketeer-full.e3dd0168.png";